import React from 'react';

const Add = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
            <path d="M256 0C114.51 0 0 114.497 0 256c0 141.49 114.497 256 256 256 141.49 0 256-114.497 256-256C512 114.51 397.503 0 256 0zm115.345 273.067h-98.278v98.278c0 9.425-7.641 17.067-17.067 17.067s-17.067-7.641-17.067-17.067v-98.278h-98.278c-9.425 0-17.067-7.641-17.067-17.067s7.641-17.067 17.067-17.067h98.278v-98.278c0-9.425 7.641-17.067 17.067-17.067s17.067 7.641 17.067 17.067v98.278h98.278c9.425 0 17.067 7.641 17.067 17.067s-7.642 17.067-17.067 17.067z" />
        </svg>
    )
}

export default Add;
